import React from "react";
import "./style.css";


export const Loading = () => {
    return (
        <div className="load_base d-flex align-items-center justify-content-center">
            <h1 className="line_anim">__</h1>
        </div>
    )
};